module.exports = __webpack_public_path__ + "img/icon44.d1bbefc9.png";